import {inject} from "@angular/core";
import {HttpErrorResponse, HttpInterceptorFn} from "@angular/common/http";
import {catchError, from, switchMap} from "rxjs";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {TokenWrapper} from "src/app/domain/domain-models";
import {NetworkStatusStore} from "src/app/infrastructure/network/network-status.store";
import {environment} from "src/app/environments/environment";

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  const dataStorageService = inject(DataStorageService);

  if (callsThirdParty(req) || req.url.includes("login")) return next(req);

  return from(dataStorageService.getValueByKey<TokenWrapper>('authToken')).pipe(
    switchMap(tokenWrapper => {
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Basic ${tokenWrapper?.token!}`
        }
      });
      return next(clonedRequest);
    })
  );
}

const callsThirdParty = (req: any) => {
  return !req.url.startsWith(environment.baseUrl);
};

export const errorResponseInterceptor: HttpInterceptorFn = (req, next) => {

  const networkStatusStore = inject(NetworkStatusStore);

  if (callsThirdParty(req)) return next(req);

  return next(req).pipe(
    catchError((errorResponse: any) => {
      if (errorResponse instanceof HttpErrorResponse && errorResponse.status === 0) {
        networkStatusStore.setOffline();
      }
      throw errorResponse
    })
  );
};
